import React from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AuthUser from "./../Auth/AuthUser";
import { useState, useEffect } from "react";
import SubMenu from "./subMenu";
import abc from "../../../../wwwroot/menuimages/accounts-icon.png";
interface MenuItems {
  name: string;
  icon: string;
  url: string;
  subMenu: SubMenuItems[];
  menuSectionID: number;
  contentType: string;
}
interface SubMenuItems {
  name: string;
  icon: string;
  url: string;
}
const LeftMenu = ({ isRefresh = false }) => {
  let isLoggedIn = false;
  const selectedMenu =
    sessionStorage.getItem("activeMenu") == null
      ? "Dashboard"
      : sessionStorage.getItem("activeMenu");
  let isShowAdminMenu =
    localStorage.getItem("isShowAdminMenu") == null
      ? ""
      : localStorage.getItem("isShowAdminMenu");
  const { http, user, getloginInfo } = AuthUser();
  const [LeftMenudata, setmenudata] = useState<MenuItems[]>([]);
  const [activeMenu, setActiveMenu] = useState<string>(selectedMenu);
  const [expandAdminenu, setExpandAdminMenu] = useState("");
  const [adminSubMenus, setAdminSubMenus] = useState<SubMenuItems[]>([]);
  const IsAuthenticated =
    getloginInfo == null ? false : getloginInfo().IsAuthenticated;
  const navigate = useNavigate();
  isLoggedIn = IsAuthenticated;
  const activechanged = (menu: string) => {
    sessionStorage.setItem("activeMenu", menu);
    if (menu != "Administration") {
      localStorage.removeItem("isShowAdminMenu");
    }
  };

  useEffect(() => {
    if (!IsAuthenticated) {
      const logout = () => {
        navigate("/login", { replace: true });
      };
    }
    fetchData();
  }, []);

  const fetchData = () => {
    const UserTypeId = user.userTypeID;
    http
      .post("/admin/menuSection/getByUserType", {
        UserTypeId: UserTypeId,
        IsRefresh: true,
      })
      .then((res) => {
        setmenudata(res.data.data);
        const adminMemu = res.data.data.find(
          (menu) => menu.name == "Administration"
        );
        const admnsubmnu = adminMemu ? adminMemu.subMenu : [];
        setAdminSubMenus(admnsubmnu);
      })
      .catch(function (error) {});
  };
  const adminMenuClick = (event, menuname) => {
    const numbers = [10, 20, 30, 40];

    const ifAdminsubMenu = adminSubMenus.some((menu) => menu.name === menuname);
    if (ifAdminsubMenu) {
      localStorage.setItem("isShowAdminMenu", " show");
    } else {
      localStorage.removeItem("isShowAdminMenu");
    }
  };
  return (
    <>
      {isLoggedIn && (
        <div className="left-side-menu">
          <div className="h-100" data-simplebar>
            <div id="sidebar-menu">
              <ul id="side-menu">
                {LeftMenudata.map((e) =>
                  e.subMenu.length > 0 ? (
                    <>
                      <li>
                        <a
                          href={"#Parent" + e.menuSectionID}
                          data-toggle="collapse"
                          className={
                            activeMenu === e.name
                              ? "collapsed active d-flex align-items-center"
                              : "collapsed d-flex align-items-center"
                          }
                          onClick={() => {
                            activechanged(e.name);
                          }}
                          aria-expanded="false"
                        >
                          {" "}
                          <img src={e.icon} alt="Image" />
                          <span>{e.name}</span>
                          <span className="menu-arrow"></span>{" "}
                        </a>

                        <div
                          className={
                            e.name == "Administration"
                              ? "collapse " + isShowAdminMenu
                              : "collapse"
                          }
                          id={"Parent" + e.menuSectionID}
                        >
                          <ul className="nav-second-level">
                            <SubMenu
                              subMenuArray={e.subMenu}
                              activeMenu={activeMenu}
                              activechanged={activechanged}
                              adminMenuClick={adminMenuClick}
                            />
                          </ul>
                        </div>
                      </li>
                    </>
                  ) : (
                    <li>
                      <Link
                        className={
                          activeMenu === e.name
                            ? "active d-flex align-items-center"
                            : "align-items-center d-flex"
                        }
                        to={e.url}
                        onClick={() => {
                          activechanged(e.name);
                        }}
                      >
                        <img src={e.icon} alt="Image" />
                        <span>{e.name}</span>
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeftMenu;
